import { BASE_JWT_URL } from 'constants/environmentVariables';
import axiosInstance from 'services/axiosConfig';
import { handleErrors } from 'actions/errors';
import { createSubmitEvent, logEvent, updateSubmitEvent } from 'services/firebaseLogger';
import { setManageDrawer } from 'reducers/manageTablesSlice';
import { currentAccountIdSelector } from 'reducers/userAuthSlice';
import { setAircraftMakes, setAircraftModels } from 'reducers/globalSlice';

export const fetchAircraftDetails = aircraft_id => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/aircraft/${aircraft_id}?appends[]=total_flight_hours&appends[]=user&appends[]=user.is_retired&appends[]=tags`;
	try {
		const response = await axiosInstance.get(url);
		dispatch(
			setManageDrawer({
				data: response.data.data
			})
		);
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const updateAircraft = (aircraft_id, payload) => async (dispatch, getState) => {
	if (Object.hasOwnProperty.call(payload, 'status')) {
		payload['airworthy'] = payload.status;
		delete payload.status;
	}
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/aircraft/${aircraft_id}`;
	try {
		const response = await axiosInstance.put(url, payload);
		dispatch(
			setManageDrawer({
				data: response.data.data
			})
		);
		logEvent(updateSubmitEvent('aircraft'));
		return response;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const postNewAircraft = payload => async (dispatch, getState) => {
	const currentAccountId = currentAccountIdSelector(getState());
	const url = `${BASE_JWT_URL}/v1/account/${currentAccountId}/aircraft`;
	try {
		const response = await axiosInstance.post(url, payload);
		logEvent(createSubmitEvent('aircraft'));
		return response.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const getAircraftModels = () => async dispatch => {
	const url = `${BASE_JWT_URL}/v1/aircraft/models`;
	try {
		const response = await axiosInstance.get(url);
		const list = response.data.data;
		const formattedList = list.map(item => {
			return {
				value: item.name,
				label: item.name
			};
		});
		dispatch(setAircraftModels(formattedList));
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};

export const getAircraftMakes = () => async dispatch => {
	const url = `${BASE_JWT_URL}/v1/aircraft/manufacturers`;
	try {
		const response = await axiosInstance.get(url);
		const list = response.data.data;
		const formattedList = list.map(item => {
			return {
				value: item.name,
				label: item.name
			};
		});
		dispatch(setAircraftMakes(formattedList));
		return response.data.data;
	} catch (error) {
		handleErrors({ errors: error, dispatch });
	}
};
